import { OrderShippingDetails } from '../shipping/shipping-details-request.model';
import { OrderShippingPackage } from '../shipping/shipping-package-request.model';
import { OrderShippingPickup } from '../shipping/shipping-pickup-details-request.model';
import { ShippingEstimate } from './shipping-estimates.model';

export class OrderShipping {
    orderShippingDetails: OrderShippingDetails;
    orderShippingPickup: OrderShippingPickup;
    orderPackageInformation: Map<number, OrderShippingPackage>;
    orderShippingEstimates: ShippingEstimate[];
}
